import axios from "axios";
import { CENTERS, SESSIONS, TRAINING_GROUPS, AVAILABLE_TRAININGS, ARCHIVE } from "../Constants/ApiConstants";
import { getApiServerProPath } from "../Helper/ReadWriteApiPath";

//#region GET
export const getFormations = async (centerId, withArchive = false, withCommon = false) => {
  const { data } = await axios.get(getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + TRAINING_GROUPS, {
    params: {
      withArchive,
      withCommon,
    },
  });
  return data;
};

export const getAvailableTrainings = async (centerId) => {
  const { data } = await axios.get(getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + AVAILABLE_TRAININGS);
  return data;
};

export const getFormationDetails = async (centerId, formationId) => {
  const { data } = await axios.get(
    getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + TRAINING_GROUPS + "/" + formationId
  );
  return data;
};
//#endregion

//#region POST
export const createCustomTrainingGroup = async (centerId, formationName, machineTrainingDetails) => {
  const formatedTraining = {
    id: 0,
    name: formationName,
    isArchived: false,
    isCustom: false,
    ...machineTrainingDetails,
  };

  return axios.post(getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + TRAINING_GROUPS, formatedTraining);
};
//#endregion

//#region PATCH
export const updateArchiveCustomTrainingGroup = async (centerId, trainingGroupId, isArchived) => {
  return axios.patch(
    getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + TRAINING_GROUPS + "/" + trainingGroupId + ARCHIVE,
    {
      patchType: 0,
      dataToModify: isArchived,
    }
  );
};
//#endregion

//#region PUT
export const updateCustomTrainingGroup = async (centerId, trainingGroupId, trainingGroup) => {
  return axios.put(
    getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + TRAINING_GROUPS + "/" + trainingGroupId,
    trainingGroup
  );
};
//#endregion

//#region DELETE
export const deleteCustomTrainingGroup = async (centerId, trainingGroupId) => {
  return axios.delete(
    getApiServerProPath() + CENTERS + "/" + centerId + SESSIONS + TRAINING_GROUPS + "/" + trainingGroupId
  );
};
//#endregion
